import Link from 'next/link'
import { Badge } from '@ui/base/badge'
import { Button } from '@ui/base/button'
import { Card } from '@ui/base/card'
import { LandingCardRow, LandingCardStripe, LandingHero, landingType } from '@ui/landing'

import { marketplaces } from './join-content'

/**
 * Отрывной ярлык поставки — единственный яркий блок первого экрана. Полоса «штрихкода» рисуется
 * повторяющимся градиентом: настоящий штрихкод здесь ничего не кодирует, а картинку пришлось бы
 * грузить отдельным запросом. На узком экране ярлык скрыт: те же числа идут строкой ниже.
 */
const ShipmentCard = () => (
  <Card variant="raised" className="hidden overflow-hidden lg:block">
    <LandingCardStripe />
    <div className="grid gap-2 px-6 py-5">
      <span className={`${landingType.eyebrow} ${landingType.mutedText}`}>Каталог Evirma</span>
      <span className="text-[19px] leading-[1.3] font-medium">Фулфилмент-оператор</span>
    </div>

    <LandingCardRow label="Аудитория" note="продавцов маркетплейсов">
      <span className={`${landingType.figure} text-primary`}>100 000+</span>
    </LandingCardRow>

    <LandingCardRow label="Стоимость размещения" note="и заявки тоже бесплатны">
      <span className={landingType.figure}>0 ₽</span>
    </LandingCardRow>

    <div className="grid gap-4 border-t px-6 py-5">
      <div
        aria-hidden="true"
        className="h-11 w-1/3"
        style={{
          backgroundImage:
            'repeating-linear-gradient(90deg, var(--foreground) 0 2px, transparent 2px 5px, var(--foreground) 5px 6px, transparent 6px 11px, var(--foreground) 11px 14px, transparent 14px 17px)',
        }}
      />
      <Button render={<Link href="/fulfillment/add" />}>Разместить фулфилмент</Button>
    </div>
  </Card>
)

/** Первый экран: обещание, площадки продавцов и ярлык с ключевыми числами каталога. */
export const JoinHero = ({ audience }: { audience: string }) => (
  <LandingHero
    badge="Фулфилмент-операторам"
    title={
      <>
        Продавцы ищут фулфилмент. <span className="text-primary">Покажите им свой</span>
      </>
    }
    leadText={`В Evirma ${audience} продавцов маркетплейсов — на сайте и в расширении. Им нужны приёмка, упаковка, маркировка и отгрузка, а исполнителя они ищут по чатам и сарафанному радио. Разместите карточку с услугами и ценами, и заявки будут приходить к вам.`}
    extra={
      <>
        <p className={`${landingType.bodyText} ${landingType.mutedText} mt-4`}>
          Размещение и заявки бесплатны. Карточку правите когда угодно.
        </p>
        <div className="mt-7 flex flex-wrap items-center gap-2.5">
          <span className={`${landingType.noteText} ${landingType.mutedText} mr-1`}>Продавцы работают с</span>
          {marketplaces.map((marketplace) => (
            <Badge key={marketplace} variant="secondary" size="lg">
              {marketplace}
            </Badge>
          ))}
        </div>
      </>
    }
    primaryAction={{ href: '/fulfillment/add', label: 'Разместить фулфилмент' }}
    secondaryAction={{ href: '/fulfillment', label: 'Посмотреть каталог' }}
    aside={<ShipmentCard />}
  />
)
